module.exports = __webpack_public_path__ + "img/badge_gray_highered-finance.366825b8.svg";